import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, LeafIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productEdition, productImage, productImageAlt, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} volumi completi`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} bonus esclusivi`
}];
export function Hero() {
  const scrollToOffer = () => document.getElementById('offerta')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden" data-id="element-82" data-mp="sb1chsl5257m">
      <div className="flex h-1 w-full" aria-hidden="true" data-id="element-83" data-mp="s9ghy2ytqm9r">
        <span className="flex-1 bg-surface" data-id="element-84" data-mp="nczrv382dxu1" />
        <span className="w-24 bg-primary shadow-glow" data-id="element-85" data-mp="neax77h5rdn9" />
        <span className="flex-1 bg-surface" data-id="element-86" data-mp="3d2lb3gldnd2t" />
      </div>

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-87" data-mp="3cz5x6h3fwa2z">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-primary/40 bg-background/55 px-4 py-2 text-[11px] font-bold uppercase tracking-[.14em] text-foreground backdrop-blur-md sm:text-xs" data-id="element-88" data-mp="384s6grzq2r4n">
          <LeafIcon className="h-4 w-4 shrink-0 text-primary drop-shadow-glow" aria-hidden="true" data-id="element-89" data-mp="3eb8x8pv9gmsm" /> {productBrand} · {productEdition}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-90" data-mp="359jahxcbqc16">
          <img src={productImage} alt={productImageAlt} className="mx-auto w-full drop-shadow-glow-lg" data-id="element-91" data-mp="2hincgih9yklh" />
        </motion.div>

        

        <div className="mt-8" data-id="element-92" data-mp="2lk8vymobdx4n">
          <Button onClick={scrollToOffer} arrow className="w-full sm:w-auto" data-id="element-93" data-mp="2lml98mj4njbd">
            Voglio l&apos;Edizione Docenti
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-foreground" data-id="element-94" data-mp="najgxmntcbeh">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-primary/25 bg-background/55 px-3 py-2 backdrop-blur-md" data-id="element-95" data-mp="ddng8345otkh">
              <Icon className="h-3.5 w-3.5 text-primary drop-shadow-glow" aria-hidden="true" data-id="element-96" data-mp="1ayt8z6bmdve2" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}